import { useState } from "react";
import { Package, UserRound } from "lucide-react";
import classicIcons from "@/data/classic-item-icons.json";
import icons from "@/data/game-icons.json";
import { cn } from "@/lib/utils";

const items: Record<string, string> = icons.items;
const heroes: Record<string, string> = icons.heroes;
const skills: Record<string, string> = icons.skills;

function GameImage({ src, className, portrait = false }: { src?: string; className?: string; portrait?: boolean }) {
  const [failedSource, setFailedSource] = useState<string>();
  const missing = !src || src === failedSource;
  return <span className={cn("game-icon", portrait && "game-icon-portrait", className)} aria-hidden="true">
    {missing ? portrait ? <UserRound size={22} /> : <Package size={19} /> : <img src={src} alt="" width={64} height={64} loading="lazy" decoding="async" onError={() => setFailedSource(src)} />}
  </span>;
}

export function HeroPortrait({ heroId, className }: { heroId: number; className?: string }) {
  return <GameImage src={heroes[String(heroId)]} portrait className={className} />;
}
export function ItemIcon({ id, className }: { id: string | null | undefined; className?: string }) {
  return <GameImage src={id ? items[id] : undefined} className={className} />;
}
export function CurrencyIcon({ currency, className }: { currency: "gold" | "ruby"; className?: string }) {
  return <GameImage src={icons.currencies[currency]} className={className} />;
}
export function SkillIcon({ id, className }: { id: string; className?: string }) {
  return <GameImage src={skills[id]} className={className} />;
}

/** EC1 NGUI sprite names match saved equipment IDs; keep this catalog separate from EC2. */
export function ClassicItemIcon({ id, className }: { id: string | null | undefined; className?: string }) {
  const items: Record<string,string> = classicIcons;
  return <GameImage src={id ? items[id] : undefined} className={className} />;
}
